import React from "react";
import styled, { css } from "styled-components";
import { ArrowIcon } from "./icons";

interface ArrowNavigatorProps extends React.HTMLAttributes<HTMLDivElement> {
	previous?: () => void;
	next?: () => void;
	small?: boolean;
}
export const ArrowNavigator: React.FC<ArrowNavigatorProps> = ({ previous, next, small, children, ...htmlProps }) => {
	return (
		<Container {...htmlProps}>
			<ArrowWrapper onClick={previous} small={small}>
				<ArrowIcon />
			</ArrowWrapper>
			{children}
			<ArrowWrapper onClick={next} small={small}>
				<ArrowIcon />
			</ArrowWrapper>
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const ArrowWrapper = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "small",
})<{ onClick?: () => void; small?: boolean }>`
	cursor: pointer;
	${({ onClick }) =>
		!onClick &&
		css`
			opacity: 0;
			cursor: initial;
		`};
	width: ${({ small }) => (small ? 30 : 40)}px;
	height: ${({ small }) => (small ? 30 : 40)}px;
	border-radius: 20px;
	flex-shrink: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${({ theme }) => theme.colors.secondaryLight};
	svg  {
		width: ${({ small }) => (small ? 14 : 18)}px;
		transition: transform ease-in-out 0.2s;
		.main-path {
			fill: ${({ theme }) => theme.colors.secondary};
		}
	}
	&:hover svg {
		transform: translateX(-2px);
	}
	&:last-child {
		transform: rotate(180deg);
		background-color: ${({ theme }) => theme.colors.secondary};
		svg  {
			.main-path {
				fill: ${({ theme }) => theme.colors.white};
			}
		}
	}
`;
